const appName = 'Kitsugi'; //Solaris
const gDrive = 'Drive';

export default {
    admin_info: 'Information',
    admin_total_users: 'Total Users',
    admin_total_sessions: 'Total Sessions',
    admin_total_clients: 'Total Clients',
    admin_users: 'Users List',
    admin_sessions: 'Sessions',
    admin_logs: 'Logs',
    admin_create_user: 'Create User',
    admin_create: 'Create',
    admin_fill_required: 'Fill in required fields',
    admin_fill_all_fields: 'All fields must be filled: Email, Password and Name',

    admin_user_logs: 'User Logs',
    admin_no_logs: 'No logs available',
    admin_all_sessions: 'All sessions',
    admin_clients: 'Clients',
    admin_user_clients: 'User Clients',
    admin_client_name: 'Name',

    admin_create_error: 'Error creating user',
    admin_create_success: 'User created successfully',
    admin_invalid_email: 'Please enter a valid email',
    admin_password_too_short: 'Password must be at least 6 characters long',
    admin_tab_info: 'Information',
    admin_tab_users: 'Users List',
    admin_tab_create: 'Create',
    admin_tab_reports: 'Reports',
    admin_email: "Email",
    admin_password: "Password",
    admin_first_name: "First Name",
    admin_last_name: "Last Name",
    admin_disable_user: "Disable",
    admin_enable_user: "Enable",

    // Desktop and navigation
    desktop_title: "Desktop",

    common_firstName: "First Name",
    common_lastName: "Last Name",
    common_save: "Save",
    common_saving: "Saving...",
    common_delete: "Delete",
    common_reset: "Reset",
    common_create: "Create",

    sideMenu_profile: "My profile",
    sideMenu_privacy: "Privacy and security",
    sideMenu_language: "Language",
    sideMenu_quickstart: "Quickstart",
    quickstart_content_welcome: "🚀 Quickstart: Get Started with Clients and Session Analysis",
    quickstart_content_descr: "This short guide will help you make your first steps and get the most out of our service.",
    quickstart_content_1: "Create Your First Client",
    quickstart_content_1_text:`Switch the sidebar menu to the "Clients" section — the button is in the bottom left corner of the screen, to the left of your avatar. The icon looks like a group of people.

You'll see the client list menu. Right now it's empty, but soon it will contain all your clients.

To add a client, click the "plus" button to the right of the search bar at the top of the menu.
Fill in the required fields and click "Create".`,
    quickstart_content_2: "Start Working with a Client",
    quickstart_content_2_text:`Click on a client in the list.
A menu will appear on the right with four tabs:

Sessions — a list of all scheduled and completed sessions.

Calendar — your planner: create new sessions or add other events and tasks.

Life Events — this section collects all events the client mentioned during your sessions.

Analysis — detailed analytics for this client based on all completed sessions.`,
    quickstart_content_3: "Create Your First Session",
    quickstart_content_3_text:`Go to the "Sessions" tab.

Click the plus button in the bottom right corner — this opens the session creation menu.

You can also set up repeating sessions — this way you'll create a linked series of sessions for easy editing in the future.`,
    quickstart_content_4:"Upload a Recording and Get an Analysis",
    quickstart_content_4_text:`Once created, your session will appear in the sessions list.

On the right side of the session item, there's an "Upload" button — use it to attach a video or audio recording.

After uploading, the system will need some time to analyze your session.
When the analysis is ready, the "Upload" button will be replaced with a "View" button — click it to see the detailed session report.`,
    quickstart_done: "🎉 All Done!",
    quickstart_done_descr: `Now you know how to get started.
Add your clients, plan sessions, and gain valuable insights — your assistant is always here to help!`,

    sideMenu_faq: "FAQ",

    faq_general_title: "General Questions",
    faq_general_q1: "What is this service and how can it help me as a psychologist?",
    faq_general_a1: "Our service helps psychologists and psychotherapists manage client lists, schedule sessions, store meeting recordings, and automatically analyze their content — so you can better track progress and dynamics.",
    faq_general_q2: "Do I need to install any application?",
    faq_general_a2: "No! You work through a browser on any device — all your data is stored in a secure cloud.",

    faq_clients_title: "Clients and Profiles",
    faq_clients_q1: "How do I add a new client?",
    faq_clients_a1: "Go to the 'Clients' section, click the 'plus' icon at the top of the menu, and fill in the required data.",
    faq_clients_q2: "Can I edit client data?",
    faq_clients_a2: "Yes! Simply select a client from the list and edit the necessary fields. All changes are saved automatically.",

    faq_sessions_title: "Sessions and Recordings",
    faq_sessions_q1: "How do I create a session?",
    faq_sessions_a1: "Go to the 'Sessions' tab for the selected client and click the 'plus' button — you can specify date, time, and also set up repetition if it's a regular meeting.",
    faq_sessions_q2: "How do I upload a session recording?",
    faq_sessions_a2: "After creating a session, click the 'Upload' button to the right of the title. Video and audio files are supported.",
    faq_sessions_q3: "How long does recording analysis take?",
    faq_sessions_a3: "Usually analysis takes from a few minutes to an hour, depending on the recording length. You'll be able to view the analysis immediately after processing.",

    faq_analysis_title: "Analysis and Privacy",
    faq_analysis_q1: "Who can see my recordings and analysis?",
    faq_analysis_a1: "Only you and the administration have access to this information.",
    faq_analysis_q2: "Can I download the session recording later?",
    faq_analysis_a2: "Yes! You can save the recording later if needed.",

    faq_support_title: "Technical Support",
    faq_support_q1: "What should I do if I have a question?",
    faq_support_a1: "You can always contact our support team via chat or email. We'll respond within one business day. You can also contact your curator for any questions.",
    faq_support_q2: "What should I do if video won't upload or errors occur?",
    faq_support_a2: "Check your internet connection stability. If the problem persists, write to support — we'll help!",
    faq_support_q3: "How can I quickly send an error report or suggestion?",
    faq_support_a3: "Use the hotkey Ctrl+/ to quickly send an error report or suggestion. This is the most convenient way to contact technical support.",
    sideMenu_settings: "Settings",
    sideMenu_help: "Help",
    sideMenu_administrator: "Administration",
    sideMenu_logout: "Logout",

    sideMenuSettings_fontSize: "Font size",
    sideMenuSettings_timezone: "Timezone",
    sideMenuSettings_timezoneAuto: "(automatically)",

    // Timezone names (UTC-12 to UTC+14)
    timezone_gmt_minus_12: "GMT-12",
    timezone_pago_pago: "Pago Pago",
    timezone_honolulu: "Honolulu",
    timezone_anchorage: "Anchorage",
    timezone_los_angeles: "Los Angeles",
    timezone_denver: "Denver",
    timezone_chicago: "Chicago",
    timezone_new_york: "New York",
    timezone_caracas: "Caracas",
    timezone_sao_paulo: "São Paulo",
    timezone_noronha: "Noronha",
    timezone_azores: "Azores",
    timezone_london: "London",
    timezone_paris: "Paris",
    timezone_kiev: "Kyiv",
    timezone_moscow: "Moscow",
    timezone_dubai: "Dubai",
    timezone_karachi: "Karachi",
    timezone_dhaka: "Dhaka",
    timezone_bangkok: "Bangkok",
    timezone_shanghai: "Shanghai",
    timezone_tokyo: "Tokyo",
    timezone_sydney: "Sydney",
    timezone_noumea: "Noumea",
    timezone_auckland: "Auckland",
    timezone_tongatapu: "Tongatapu",
    timezone_kiritimati: "Kiritimati",

    sideMenuPrivacy_updatePassword: "Update password",
    sideMenuPrivacy_oldPassword: "Current password",
    sideMenuPrivacy_newPassword: "New password",
    sideMenuPrivacy_changePassword: "Change password",

    bottomMenu_Sessions: 'Sessions',
    bottomMenu_Notes: "Notes",
    bottomMenu_Chat: 'Chat',
    bottomMenu_Calendar: 'Calendar',
    bottomMenu_Lifeline: 'Lifeline',
    bottomMenu_Analysis: 'Analysis',
    bottomMenu_Statistic: 'Statistic',
    bottomMenu_Mindmap: 'Mindmap',
    mindmap_new_board: 'New Board',
    mindmap_delete: 'Delete',
    mindmap_delete_confirm: 'Delete this board?',
    mindmap_basic: 'Basic',
    mindmap_box: 'box',
    mindmap_round: 'round',
    mindmap_triangle: 'triangle',
    mindmap_trapezoid: 'trapezoid',
    mindmap_star: 'star',
    mindmap_sticker: 'sticker',
    mindmap_delete_block: 'Delete',
    mindmap_delete_cancel: 'Cancel',
    mindmap_export: 'Export JSON',
    mindmap_context_export: 'Export',
    mindmap_context_delete: 'Delete',
    mindmap_arrows: 'Arrows',
    mindmap_arrow_thin: 'Thin arrow',
    mindmap_arrow_thick: 'Thick arrow',
    mindmap_arrow_hollow: 'Hollow arrow',
    mindmap_arrows_manual: 'Manual',
    mindmap_arrow_manual_thin: 'Manual thin',
    mindmap_arrow_manual_thick: 'Manual thick',
    mindmap_arrow_manual_hollow: 'Manual hollow',
    mindmap_arrows_auto: 'Auto',
    mindmap_arrows_straight: 'Straight',
    mindmap_arrow_straight_thin: 'Straight thin',
    mindmap_arrow_straight_thick: 'Straight thick',
    mindmap_arrow_straight_hollow: 'Straight hollow',
    mindmap_arrows_block: 'With text',
    mindmap_arrow_block: 'Block arrow with text',
    mindmap_arrow_hint: 'Select an arrow style, then click two orange snap points to connect shapes',
    mindmap_manual_hint_line1: 'Segment: drag (Shift=free) | Point: drag (Shift=align)',
    mindmap_manual_hint_line2: 'Double-click: add point | Right-click: delete',
    mindmap_center_camera: 'Center all',
    mindmap_undo: 'Undo (Ctrl+Z)',
    mindmap_reset_zoom: 'Reset zoom',
    mindmap_fullscreen: 'Fullscreen',
    mindmap_exit_fullscreen: 'Exit fullscreen',
    mindmap_other: 'Other',
    mindmap_text: 'Text',
    mindmap_text_placeholder: 'Enter text...',
    mindmap_draw: 'Draw',
    mindmap_draw_color: 'Color',
    mindmap_draw_width: 'Width',
    mindmap_media: 'Media',
    mindmap_add_media: 'Add Media',
    mindmap_media_url: 'URL',
    mindmap_media_url_placeholder: 'https://example.com/image.jpg',
    mindmap_upload_file: 'Upload File',
    mindmap_or: 'or',
    mindmap_add: 'Add',
    mindmap_folders: 'Folders',
    mindmap_folders_filter_client: 'Only client folders',
    mindmap_folders_empty: 'No folders found',
    mindmap_folders_no_subfolders: 'No subfolders',
    mindmap_folders_open: 'Open folder',
    mindmap_notes: 'Notes',
    mindmap_notes_empty: 'No notes found',
    mindmap_untitled_note: 'Untitled',
    mindmap_tasks: 'Tasks',
    mindmap_tasks_filter_client: 'Only client tasks',
    mindmap_tasks_empty: 'No tasks found',
    mindmap_untitled_task: 'Untitled',
    mindmap_settings: 'Settings',
    mindmap_background_color: 'Background',
    mindmap_background_type_color: 'Color',
    mindmap_background_type_cork: 'Board',
    mindmap_show_dots: 'Show dots',
    mindmap_fill: 'Fill',
    mindmap_text_color: 'Text color',
    mindmap_border: 'Border',
    mindmap_show_all: 'Show all',
    mindmap_show_client_only: 'Show client only',
    back: 'Back',

    'dashboard_page_title': 'Dashboard',

    // Notes Widget
    'notes_widget_title': 'Notes',
    'notes_widget_view_all': 'View all notes',
    'notes_widget_no_notes': 'No notes yet',
    'notes_widget_create_first': 'Create your first note',

    login_Appname: appName.toUpperCase(),
    login_LoginText: "Log In to "+appName,
    login_AllRightsText: "All Rights Reserved. "+appName,
    login_email: "Email address",
    login_password: "Password",
    login_remember_me: "Remember Me",
    login_forgot_password: "Forgot Password?",
    login_proceed: "Proceed",
    login_sign_up: "Sign up",
    
    signup_title: "Create an account",
    signup_name: "Name",
    signup_email: "Email address",
    signup_password: "Password",
    signup_repeat_password: "Repeat password",
    signup_remember_me: "Remember Me",
    signup_proceed: "Proceed",
    signup_or: "or",
    signup_google: "Sign in with Google",
    signup_login: "Login",
    
    analysis_file_name: "File Name:",
    analysis_content: "Analysis Content:",
    analysis_file_placeholder: "Enter file name (e.g., 'session-notes')",
    analysis_content_placeholder: "Enter your analysis text here...",
    analysis_create_file: "Create New File",
    analysis_append_to: "Append to",
    analysis_error_empty: "Please enter both a file name and analysis content",
    analysis_error_content: "Please enter analysis content to append",
    
    common_back: "Back",
    common_user_avatar: "User avatar",
    common_report_screenshot: "Report screenshot",
    common_error_prefix: "Error: ",

    gDrive: gDrive,
    desktop_uploadFile: 'Upload file',
    desktop_uploadGDrive: `Add ${gDrive} file`,
    desktop_resetPositions: `Reset\u00A0positions`,
    desktop_deleteFromGDrive: `Delete\u00A0from\u00A0${gDrive}`,
    desktop_deleteSelectedFiles: (count: string | number)=>`Delete\u00A0selected\u00A0${count}\u00A0files`,
    desktop_delete: (name: string)=>`Delete\u00A0${name}`,
    desktop_addAnalysis: "Add analysis",
    desktop_createFolder: "Create folder",
    desktop_rename: "Rename",
    desktop_moveFilesUp: "Move files up",
    desktop_options: "Options...",

    'Files are located at gDrive': `Files are located at ${gDrive}`,
    'Select gDrive file': `Select ${gDrive} file`,
    'Client': 'Client',
    'All clients': 'All clients',
    'account_disabled': 'Account disabled',

    allTime: 'All Time',
    lastYear: 'Last Year',
    lastMonth: 'Last Month',
    lastWeek: 'Last Week',

    hotkeys_title: 'Hotkeys',
    hotkeys_general: 'General',
    hotkeys_navigation: 'Navigation',
    hotkeys_show_window: 'Show this window',
    hotkeys_close_modal: 'Close modal window',
    hotkeys_save: 'Save',
    hotkeys_undo: 'Undo',
    hotkeys_message_placeholder: 'Enter your message...',
    hotkeys_send_report: 'Send Report',
    report_title: 'Report',
    'report.screenshot': 'Screenshot',
    'report.logs': 'Logs',
    'report.no_logs': 'No logs available',
    'report.deleted': 'Report deleted',
    'report.delete_error': 'Error deleting report',

    // Admin panel translations
    'admin_loading_reports': 'Loading reports...',
    'admin_reports_count': 'Reports',
    'admin_no_reports': 'No reports found',
    'admin_report_open': 'Open',
    'admin_report_delete': 'Delete',
    'admin_all_time': 'All Time',
    'admin_last_week': 'Last Week',
    'admin_last_month': 'Last Month',
    'admin_last_year': 'Last Year',
    'admin_dataset_all': 'All',
    'admin_dataset_users': 'Users',
    'admin_dataset_sessions': 'Sessions',
    'admin_dataset_clients': 'Clients',
    'admin_loading_sessions': 'Loading sessions...',
    'admin_no_sessions': 'No sessions available',
    'admin_show_json': 'Show JSON',
    'admin_hide_json': 'Hide JSON',
    'admin_loading_clients': 'Loading clients...',
    'admin_no_clients': 'No clients available',
    'admin_client_sessions': 'Client Sessions',
    'admin_no_client_sessions': 'No sessions available for this client.',
    'admin_session_id': 'ID',
    'admin_prediction_id': 'Prediction ID',
    'admin_date': 'Date',
    'admin_client_id': 'Client ID',
    'admin_title': 'Title',
    'admin_status': 'Status',
    'admin_date_to': 'Date To',

    age_years_1: 'year',
    age_years_2_4: 'years', 
    age_years_5_plus: 'years',
    'events_without_dates': 'Events without dates',
    'events': 'Events',
    'lifeline_title': 'Lifeline',
    'lifeline_add_event': 'Add an event',
    'lifeline_loading': 'Loading events...',
    'lifeline_go_to_session': 'Go to session',
    'lifeline_no_events': 'No events found',
    'error_prefix': 'Error:',
    'lifeline_create_error': 'Error creating event',
    'lifeline_show_all_events': 'Show all events',
    'lifeline_hide_unimportant': 'Hide unimportant events',
    'lifeline_event_type': 'Event type',
    'lifeline_positive_event': 'Positive event',
    'lifeline_negative_event': 'Negative event',
    'lifeline_important_event': 'Important event',
    'lifeline_importance_level': 'Importance level',
    'lifeline_event_title': 'Event',
    'lifeline_event_description': 'Description',
    'lifeline_event_date': 'Event date',
    'lifeline_save_event': 'Save event',
    'lifeline_cancel': 'Cancel',
    'lifeline_edit_event': 'Edit event',
    'lifeline_delete_event': 'Delete event',
    'lifeline_save_changes': 'Save changes',
    'lifeline_loading_save': 'Saving...',
    'lifeline_error_save': 'Error saving',
    'lifeline_success_save': 'Event saved',
    'lifeline_error_load': 'Error loading events',
    'lifeline_error_delete': 'Error deleting event',
    'lifeline_confirm_delete': 'Are you sure you want to delete this event?',
    'lifeline_from_session_date': 'From [date] session',
    'client_confirm_delete': 'Are you sure you want to delete this client?',
    'common_loading': 'Loading...',
    'common_error': 'Error',
    'common_success': 'Success',
    'common_cancel': 'Cancel',
    'common_edit': 'Edit',
    'common_confirm': 'Confirm',
    'common_yes': 'Yes',
    'common_no': 'No',
    'common_show_more': 'Show more',
    'common_show_less': 'Show less',
    'meeting_back': 'Back',
    'no_client_selected': 'No client selected',
    'select_note_edit': 'Select note for edit or add new one',
    'full_analysis_one_list': 'One list',
    'full_analysis_one_list_desc': 'Show all records for selected client as one analysis file',
    'full_analysis_all_files': 'All clients',
    'full_analysis_all_files_desc': 'Show files from all clients',
    'clients_switch_clients': 'Clients',
    'clients_switch_schedule': 'Schedule',
    'search_clients_placeholder': 'Clients',
    'sideMenu_desktop': 'Desktop',
    'sideMenu_startScreen': 'Start screen',
    'day_sun': 'SUN',
    'day_mon': 'MON',
    'day_tue': 'TUE',
    'day_wed': 'WED',
    'day_thu': 'THU',
    'day_fri': 'FRI',
    'day_sat': 'SAT',
    'day_sunday': 'Sunday',
    'day_monday': 'Monday',
    'day_tuesday': 'Tuesday',
    'day_wednesday': 'Wednesday',
    'day_thursday': 'Thursday',
    'day_friday': 'Friday',
    'day_saturday': 'Saturday',
    'loading': 'Loading...',
    'calendar_day': 'Day',
    'calendar_week': 'Week',
    'calendar_month': 'Month',
    'calendar_year': 'Year',
    'calendar_today': 'Today',
    'month_january': 'January',
    'month_february': 'February',
    'month_march': 'March',
    'month_april': 'April',
    'month_may': 'May',
    'month_june': 'June',
    'month_july': 'July',
    'month_august': 'August',
    'month_september': 'September',
    'month_october': 'October',
    'month_november': 'November',
    'month_december': 'December',
    'month_jan': 'Jan',
    'month_feb': 'Feb',
    'month_mar': 'Mar',
    'month_apr': 'Apr',
    'month_may_short': 'May',
    'month_jun': 'Jun',
    'month_jul': 'Jul',
    'month_aug': 'Aug',
    'month_sep': 'Sep',
    'month_oct': 'Oct',
    'month_nov': 'Nov',
    'month_dec': 'Dec',
    'schedule_no_sessions_found': 'No sessions found',
    'schedule_no_sessions_match_search': 'No sessions match your search',
    'session_upload': 'Upload',
    'session_wait': 'Wait...',
    'session_watch': 'Watch',
    'session_error': 'Error',
    'session_status_upcoming': 'Upcoming',
    'session_status_finished': 'Finished',
    'session_status_cancelled': 'Cancelled',
    'session_processing': 'Processing...',
    'session_with': 'Session with',
    'view_profile': 'View profile',
    'transcription_of_session': 'Transcription of session',
    'minimize': 'Minimize',
    'most_used_words': 'Most used words',
    'session_statistics': 'session\'s statistics',
    'most_common_word': 'Most common word',
    'used': 'used',
    'times': 'times',
    'during_all_sessions': 'during all sessions',
    'used_word_today_first_time': 'used that word today for the first time',
    'word_appeared_in_speech': 'word "[word]" appeared in the client\'s speech during [session] session',
    'word_appeared_in_sessions': '"[word]" appeared in [count] sessions',
    'highlights_previous_session': 'Highlights from the previous session',
    'recommendations_upcoming_session': 'Recommendations for the upcoming session:',
    'add_task': 'Add a task',
    'plan_new_session': 'Plan a new session',
    'open_previous_statistic': 'Open previous statistic',
    'fear_public_speaking': 'Fear of an upcoming public speaking',
    'doubts_attractiveness': 'Doubts about your attractiveness',
    'panic_attacks': 'Panic attacks',
    'breathing_exercises': 'Breathing exercises',
    'appointment_psychiatrist': 'Make an appointment with a psychiatrist',
    'calming_scheme': 'Scheme for calming down before a public speech',
    'meetingPage_todays_speed': 'Today\'s speed',
    'meetingPage_session_statistics': 'session\'s statistics',
    'meetingPage_graphicSpeed_title': 'Louder speech',
    'meetingPage_graphicSpeed_text': '[name] was [percent]% louder than usual today',
    'meetingPage_taciturnity_title': 'Taciturnity',
    'meetingPage_taciturnity_text': '[name] was silent for [percent]% of the session today',
    'meetingPage_graphicSpeed_bottom_a': 'average speed',
    'meetingPage_graphicSpeed_bottom_b': 'words per minute',
    'meetingPage_todays_average_speed': 'Today\'s average speed',
    'meetingPage_words_per_minute': 'words per minute',
    'meetingPage_volume_title': 'Volume Analysis',
    'meetingPage_volume_subtitle': 'Session volume levels over time',
    'meetingPage_volume_average': 'Average volume',
    'meetingPage_average_speed_title': 'Average Speed',
    'meetingPage_average_speed_subtitle': 'Speaking speed across sessions',
    'meetingPage_average_speed_bottom': 'words per minute',
    'common_at': 'at',
    'task_assigned_to_session': 'Assigned to session',
    'session_no_description': 'No description for this session',
    'debug_analyze_session': 'Analyze session',
    'debug_watch_video': 'Watch video',
    'debug_add_task': 'Add a task',
    'debug_chat': 'Chat',

    // Session creation
    'session_new_session': 'New session',
    'session_edit_session': 'Edit session',
    'session_add_title': 'Add title',
    'session_select_date': 'Select session date',
    'session_start_time': 'Start time',
    'session_end_time': 'End time',
    'session_add_task': 'Add task',
    'session_add_description': 'Add a description or attachment',
    'session_save_draft': 'Save draft',
    'session_delete': 'Delete',
    'session_save': 'Save',
    'session_create': 'Create',

    // Repeat options
    'repeat_every': 'Repeat every: ',
    'repeat_interval': 'Repeat interval: ',
    'repeat_dont_repeat': 'Don\'t repeat',
    'repeat_everyday': 'everyday',
    'repeat_every_other_day': 'every other day',
    'repeat_every_week': 'every week',
    'repeat_every_two_weeks': 'every two week',
    'repeat_every_month': 'every month',
    'repeat_custom': 'custom',
    'repeat_number_of_sessions': 'Number of sessions: ',
    'repeat_number_of_events': 'Number of events: ',
    'repeat_sessions_label': 'repeat: ',

    // Calendar event form
    'calendar_event_start_time': 'start time',
    'calendar_event_end_time': 'end time',
    'calendar_event_text': 'event text',
    'calendar_event_delete_all': 'Delete all',
    'calendar_event_save_all': 'Update this and following',
    'calendar_event_event': 'Event',
    'calendar_event_task': 'Task',
    'calendar_event_session': 'Session',
    'calendar_new_event': 'New event',
    'calendar_new_task': 'New task',
    'calendar_new_session': 'New session',
    'calendar_edit_event': 'Edit event',
    'calendar_edit_task': 'Edit task',
    'calendar_edit_session': 'Edit session',

    // Validation messages
    'validation_enter_date': 'Enter date',
    'validation_enter_start_time': 'Enter start time',
    'validation_enter_end_time': 'Enter end time',

    // Analysis folder management
    'analysis_create_new_folder': 'Create new folder',
    'analysis_add_file': 'Add file',

    // Load more functionality
    'load_more': 'Load More',
    'no_more_sessions': 'No more sessions to load',

    // Subtitles context menu
    'subtitles_context_edit': 'Edit',
    'subtitles_context_comment': 'Comment',
    'subtitles_context_send_to': 'Send to...',
    'subtitles_context_folder': 'Folder',
    'subtitles_context_desktop': 'Desktop',
    'subtitles_context_add_tag': 'Add tag',
    'subtitles_context_assign': 'Assign...',
    'subtitles_context_red_flag': 'Red flag',
    'subtitles_context_attention': 'Attention',
    'subtitles_context_edit_fast_actions': 'Edit fast actions',

    // Comment popup
    'subtitles_comment_add': 'Add comment',
    'subtitles_comment_close': 'Close',
    'subtitles_comment_done': 'Done',

    // Send to desktop functionality
    'subtitles_select_text_to_send': 'Please select text to send to desktop',
    'subtitles_no_text_selected': 'No text selected',
    'subtitles_quote_from_meeting': 'Quote from Meeting',
    'subtitles_meeting_quote_tag': 'Meeting Quote',
    'subtitles_selected_text_title': 'Selected Text from Meeting',
    'subtitles_text_saved_success': 'Text saved to desktop successfully!',
    'subtitles_save_failed': 'Failed to save text to desktop. Please try again.',

    // Send to folder functionality
    'send_folder_client_tag': 'Client',
    'send_folder_quote_title': 'Quote from session: ',
    'send_folder_preview': 'Preview',
    'send_folder_action_text': 'A note you added from the',
    'send_folder_session_suffix': 'session',
    'send_folder_send_to_selected': 'Send to selected file',
    'send_folder_create_and_send': 'Create file and send',
    'send_folder_default_filename': 'file.analysis',

    // Meeting page error messages
    'meeting_auth_error': 'Authentication error occurred',
    'meeting_invalid_response': 'Invalid response format from server',
    'meeting_processing_error': 'Error processing server response',
    'meeting_network_error': 'Network error occurred while deleting word',
    'meeting_default_name': 'They',

    // Tasks
    'tasks_title': 'Tasks',
    'tasks_add': 'Add Task',
    'tasks_add_new': 'Add a new task',
    'tasks_new_task': 'New task',
    'tasks_edit': 'Edit Task',
    'tasks_all_tags': 'All Tags',
    'tasks_empty': 'No tasks yet. Click "Add Task" to create one.',
    'tasks_load_error': 'Failed to load tasks',
    'tasks_save_error': 'Failed to save task',
    'tasks_delete_error': 'Failed to delete task',
    'tasks_confirm_delete': 'Delete this task?',
    'tasks_title_required': 'Please enter a task title',
    'tasks_field_title': 'Title',
    'tasks_field_datetime': 'Date & Time',
    'tasks_field_tags': 'Tags',
    'tasks_has_date': 'Schedule for specific date/time',
    'tasks_title_placeholder': 'Enter task title...',
    'tasks_tag_placeholder': 'Add a tag...',
    'tasks_field_description': 'Description',
    'tasks_description_placeholder': 'Add details about this task...',
    'tasks_datetime_label': 'Date & Time',
    'tasks_assign_to_session': 'Assign to session',
    'tasks_session_none': 'None',
    'tasks_session_untitled': 'Untitled Session',
    'tasks_no_future_sessions': 'No future sessions available',
    
    // Analysis
    'analysis_title': 'Analysis',
    'analysis_add_folder': 'Add a new folder',
    'analysis_new_folder': 'New Folder',
    'analysis_confirm_delete': 'Delete',
    'analysis_select_client': 'Select a client to view analysis',
    'analysis_filter_client': 'Show only this client\'s files',
    'analysis_empty_folder': 'No files or folders yet',

    // Notes
    'notes_title': 'Notes',
    'notes_add': 'Add note',
    'notes_add_new': 'Add a new note',
    'notes_new_title': 'New note',
    'notes_remove': 'Delete',
    'notes_save': 'Save note',
    'notes_empty': 'No notes yet. Click "Add note" to create one.',
    'notes_select_or_create': 'Select a note or create a new one',
    'notes_confirm_delete': 'Delete this note?',
    'notes_load_error': 'Failed to load notes',
    'notes_save_error': 'Failed to save note',
    'notes_delete_error': 'Failed to delete note',
    'notes_deleted_success': 'Note deleted successfully',
    'notes_bound_to_client': 'Bound to client',
    'tasks_bound_to_client': 'Bound to client',

    // Filter tooltips
    'filter_show_all_notes': 'Show all notes',
    'filter_show_client_notes': 'Show only {name}\'s notes',
    'filter_show_all_tasks': 'Show all tasks',
    'filter_show_client_tasks': 'Show only {name}\'s tasks',
    'filter_show_all_files': 'Show all files',
    'filter_show_client_files': 'Show only {name}\'s files',

    // Goals
    'goals_title': 'Goals',
    'goals_add': 'Add goal',
    'goals_edit': 'Edit Goal',
    'goals_empty': 'No goals yet. Click "Add goal" to create one.',
    'goals_select_client': 'Select a client to view goals',
    'goals_field_emoji': 'Emoji',
    'goals_field_title': 'Goal Title',
    'goals_field_start_date': 'Start Date',
    'goals_select_emoji': 'Select emoji',
    'goals_title_placeholder': 'e.g., days without smoking',
    'goals_title_required': 'Please enter a goal title',
    'goals_confirm_delete': 'Delete this goal?',
    'goals_confirm_reset': 'Reset this goal to day 0?',
    'goals_reset': 'Reset to day 0',
    'goals_delete': 'Delete goal',
    'goals_click_to_edit_days': 'Click to edit days',
    'goals_load_error': 'Failed to load goals',
    'goals_save_error': 'Failed to save goal',
    'goals_delete_error': 'Failed to delete goal',
    'goals_reset_error': 'Failed to reset goal',
    'goals_update_error': 'Failed to update goal',
    'goals_add_new': 'Add a new goal',

    // Bottom menu
    'bottomMenu_Tasks': 'Tasks',

    // Statistics page
    'statistic_title': 'Statistics',
    'statistic_select_client': 'Select a client to view statistics',
    'statistic_all_time': 'All time',
    'statistic_month': 'Month',
    'statistic_week': 'Week',
    'statistic_custom': 'Custom range',
    'statistic_most_used_words': 'Most used words',
    'statistic_no_data': 'No data available',
    'statistic_average_speed': 'Average Speech Speed',
    'statistic_speed_subtitle': 'Across all sessions',
    'statistic_avg_speed_label': 'Average speed',
    'statistic_volume': 'Speech Volume',
    'statistic_volume_subtitle': 'Volume levels across sessions',
    'statistic_avg_volume': 'Average volume',
    'statistic_silence': 'Silence',
    'statistic_silence_label': 'Average silence percentage',
    'statistic_session': 'Session',

    'connection_lost': 'Connection Lost',
    'connection_lost_message': 'We\'re having trouble connecting to the server. Please check your internet connection.',
    'connection_retry_in': 'Retrying in',
    'connection_retrying': 'Connecting...',
    'connection_retry_now': 'Try Now',
}